import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import './copyInvestors.css'
import AuthContext from 'contexte/AuthContext';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import { formatDate } from 'utils/date';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import { fetchActiveCopyInvestors } from 'services/copyInvestServices';
import { useParams, useSearchParams } from 'react-router-dom';

const CopyInvestors = () => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [fetchLimit, setFetchLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [investors, setInvestors] = useState([]);

  const fetchData = async () => {
    try {
      const data = await fetchActiveCopyInvestors(user, page, fetchLimit)
      setInvestors(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [fetchLimit, page])

  function transformDataToTBody(data) {

    return data.map(item => {

      return {
        data: [
          item.full_name,
          item.total_invested,
          item.available
        ]

      };
    });
  }



  return (
    <DashboardLayout page={t("pages_name.copy_investors")}>
      <div>
        <h1>{t('pages.copy_investors.title')}</h1>
        {!loading ? (
          <div>
            <div className='copy_investors_title_component'>
              <div className='copy_investors_filter_component'>

                <FilterComponent
                  limit={true}
                  fetchLimit={fetchLimit} setFetchLimit={setFetchLimit}
                />
              </div>
            </div>
            <Tableau
              thead={["Utilisateur", "Total Investi", "Total Disponible"]}
              tbody={transformDataToTBody(investors)}
              limit={fetchLimit}
              pagination setPage={setPage} page={page}
            />
          </div>
        ) : (
          <div>Loading..</div>
        )}
      </div>
    </DashboardLayout>
  )
}

export default CopyInvestors